import {HttpModelConverter} from "../../../../core/converter/httpModel.converter";
import {TagModel} from "./tag.model";
import {Injectable} from "@angular/core";
import {TagSummaryConverter} from "./tagSummary.converter";
import {LovValueSummaryConverter} from "../../../lov/lov-value/api/converter/LovValueSummary.converter";
@Injectable({
    providedIn: 'root'
})
export class TagConverter extends HttpModelConverter<TagModel>{

    constructor(private summaryConverter: TagSummaryConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): TagModel {
        return new TagModel();
    }

    protected enrichObject(result: TagModel, src: TagModel) {
        result.summary = this.summaryConverter.convert(src.summary);
        result.entityType = this.lovValueSummaryConverter.convert(result.entityType);
    }

}